import { injectIntl } from "react-intl";
import type { intlFormatPropTypes } from "react-intl";
import { useSelector } from "react-redux";

import { Item } from "@ps-design-system/components/ItemV2";
import StarIcon from "@ps-design-system/icons/Star/Star24";

import { selectProfileSSOid } from "../../app-main/selectors/profile.selectors";
import { trackRecommendedItemClicked } from "../analytics/host-hub-analytics";
import type { SubmitGuestReviewCardData } from "../types/model/submit-guest-review";
import { openHostHubReviewModal } from "../utils/host-hub-review-modal.utils";

type HostHubSubmitGuestReviewItemProps = {
  card: SubmitGuestReviewCardData;
  intl: intlFormatPropTypes;
  onReviewSubmitted: () => void;
};

const HostHubSubmitGuestReviewItem = ({
  card,
  intl,
  onReviewSubmitted,
}: HostHubSubmitGuestReviewItemProps) => {
  const ssoid = useSelector(selectProfileSSOid);

  const { guestAvatarUrl, guestName, listingPhotoUrl, listingTitle, review } =
    card;

  const title = intl.formatMessage({
    defaultMessage: "Submit a review of your guest",
    id: "host_hub.todo_list.submit_review_title",
  });

  const handleClick = () => {
    trackRecommendedItemClicked({ parameter: "submit_guest_review", ssoid });
    openHostHubReviewModal({
      onReviewSubmitted,
      review,
      ssoId: ssoid,
    });
  };

  const mediaProps = listingPhotoUrl
    ? { media: listingPhotoUrl, mediaAlt: listingTitle }
    : { icon: <StarIcon /> };

  return (
    <Item
      avatar={guestAvatarUrl}
      avatarAlt={guestName}
      buttonOnClick={handleClick}
      mediaSize={56}
      size="lg"
      title={title}
      variant="outline"
      {...mediaProps}
    />
  );
};

export default injectIntl(HostHubSubmitGuestReviewItem);
